export const parseRestTime = (rawValue) => {
    if (rawValue === undefined || rawValue === null) return 60;
    const rStr = String(rawValue).toLowerCase().trim();
    const match = rStr.match(/([\d.]+)/);
    if (!match) return 60;
    let val = parseFloat(match[1]);
    if (rStr.includes('min') || rStr.includes('m')) {
        val = val * 60;
    }
    return Math.round(val);
};

export const isBarbellExercise = (name) => {
    return /barbell|smith|squat|deadlift|bench press|overhead press|clean|snatch|jerk/i.test(name);
};

export const calculatePlates = (totalWeight, barWeight = 20) => {
    let perSide = (totalWeight - barWeight) / 2;
    if (perSide <= 0) return [];
    const availablePlates = [25, 20, 15, 10, 5, 2.5, 1.25];
    const platesUsed = [];
    for (let p of availablePlates) {
        while (perSide >= p) {
            platesUsed.push(p);
            perSide -= p;
        }
    }
    return platesUsed;
};

// Ontvangt nu expliciet 'history' als tweede parameter
export const getPreviousWorkoutData = (exName, history) => {
    if(!history || !Array.isArray(history)) return { weights: [], u: 'KG' };
    const cleanSearch = exName.toLowerCase().trim();

    for (let wod of history) {
        if(!wod.description) continue;
        const lines = wod.description.split('\n');
        for (let line of lines) {
            const matchNew = line.match(/^-\s*(?:[A-Z]\d?\s*-\s*)?(.*?):\s*(.*)/);
            if (matchNew && matchNew[1].toLowerCase().includes(cleanSearch) && !line.includes('(Overgeslagen)')) {
                const setsStr = matchNew[2].split(',');
                let weightsArray = [];
                let lastUnit = 'KG';

                setsStr.forEach(set => {
                    const wMatch = set.match(/x([\d.]+)(kg|lbs)/i);
                    if (wMatch) {
                        weightsArray.push(parseFloat(wMatch[1]));
                        lastUnit = wMatch[2].toUpperCase();
                    } else {
                        weightsArray.push(weightsArray.length > 0 ? weightsArray[weightsArray.length-1] : 0);
                    }
                });
                if (weightsArray.length > 0) return { weights: weightsArray, u: lastUnit };
            }

            const matchOld = line.match(/-\s*(\d+)x([\d-]+)\s+(.*?)\s*\(([\d.]+)(kg|lbs)\)/i);
            if (matchOld && matchOld[3].toLowerCase().includes(cleanSearch)) {
                const numSets = parseInt(matchOld[1], 10) || 1;
                const weightVal = parseFloat(matchOld[4]);
                const unitVal = matchOld[5].toUpperCase();
                return { weights: Array(numSets).fill(weightVal), u: unitVal };
            }
        }
    }
    return { weights: [], u: 'KG' };
};
